import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ServerContextService } from '../../../../feature-vault/src/lib/servers/server-context.service';
import type { DashboardStatsResponse } from '../../../../domain/src/lib/dashboard/dashboard.model';
import {
  resolveTenantId,
  tenantHeaders,
  withTenantParam,
} from '../shared/tenant-context.util';

@Injectable({ providedIn: 'root' })
export class DashboardService {
  private readonly http = inject(HttpClient);
  private readonly serverContext = inject(ServerContextService);
  private readonly basePath = '/api/dashboard';

  getStats(): Observable<DashboardStatsResponse> {
    const tenantId = resolveTenantId(this.serverContext);
    const params = withTenantParam(tenantId);
    return this.http.get<DashboardStatsResponse>(`${this.basePath}/stats`, {
      headers: tenantHeaders(tenantId),
      ...(params ? { params } : {}),
    });
  }

  /** Lista de tareas pendientes (forma flexible según rol). */
  getTasks(): Observable<Record<string, unknown>[]> {
    const tenantId = resolveTenantId(this.serverContext);
    const params = withTenantParam(tenantId);
    return this.http.get<Record<string, unknown>[]>(`${this.basePath}/tasks`, {
      headers: tenantHeaders(tenantId),
      ...(params ? { params } : {}),
    });
  }
}
